import $httpService from '../../common/utils'
import * as types from "../mutation-type"

export default {
  state: {
    QRcode: {},
    Login: {},
    info:{},
    UpdateInfo:{},
    Add:{},
    Delete:{},
    
  },
  mutations: {
    [types.SET_USER_QRCODE](state, payload) {
      state.QRcode = payload.info
    },
    [types.SET_USER_LOGIN](state, payload) {
      state.Login = payload.info;
    },
    [types.SET_USER_INFO](state, payload) {
      state.info = payload.info;
    },
    [types.SET_USER_UPDATE_INFO](state, payload) {
      state.UpdateInfo = payload.info;
    },
    [types.SET_USER_ADD](state, payload) {
      state.Add = payload.info;
    },
    [types.SET_USER_DELETE](state, payload) {
      state.Delete = payload.info;
    }
  },
  actions: {
    GetQRcode({dispatch, commit}, $param) {
      return $httpService.get('/users/web_login_qrcode', {
      }).then(response => {
        let list = response.result


        commit({
          type: types.SET_USER_QRCODE,
          info: response.result
        })
      }).catch(error => {
        console.log(error)
      })
    },
    GetUserInfo({dispatch, commit}, $param) {
      return $httpService.get('/users/login_user_info?code='+$param.id).then(response => {
        let list = response.result
        /* console.log(response.headers.get('ONT_EXP_TOKEN')) */
        console.log(response)
        commit({
          type: types.SET_USER_LOGIN,
          info: response.result
        })
      }).catch(error => {
        if(error.code==61013 || error.code==61012){
          console.log(error.code)
          commit({
            type: types.SET_USER_LOGIN,
            info: error.code
          })
        }else{
          console.log(error)
        }
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js